/**
 * Erros e rastreio dos fronts (painel e area do trader) no Sentry. O rastreio segue do navegador pros nossos servicos
 * (so eles: nunca pra Pagar.me, que recusaria o cabecalho). Sem replay de tela (o checkout tem dado pessoal) e sem
 * `SENTRY_DSN`, nada sai.
 */
import * as Sentry from "@sentry/browser";
import { novoCodigo } from "./codigo.js";
import { mascararValor } from "./mascarar.js";
const origem = (url) => {
    try {
        return new URL(url).origin;
    }
    catch {
        return null;
    }
};
export function iniciarNoNavegador(o) {
    if (!o.dsn)
        return false;
    Sentry.init({
        dsn: o.dsn,
        environment: o.ambiente || "local",
        release: o.versao || undefined,
        sendDefaultPii: false,
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 1,
        tracePropagationTargets: o.apis.map((a) => (a ? origem(a) : null)).filter((a) => Boolean(a)),
        initialScope: { tags: { app: o.app } },
        beforeSend: (evento) => mascararValor(evento),
        beforeSendTransaction: (evento) => mascararValor(evento),
        beforeBreadcrumb: (migalha) => mascararValor(migalha),
    });
    return true;
}
/** Erro que a tela pegou (tela quebrada, servico fora pro navegador): vai pro Sentry e volta o codigo pra mostrar. */
export function capturarNoNavegador(erro, contexto) {
    const codigo = novoCodigo();
    Sentry.withScope((escopo) => {
        escopo.setTag("codigo", codigo);
        if (contexto)
            escopo.setContext("tela", mascararValor(contexto));
        Sentry.captureException(erro);
    });
    return codigo;
}
//# sourceMappingURL=navegador.js.map